'use strict';

var cov_jko19f4gi = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/datamart-indicator/datamart-indicator.component.js',
      hash = '1a70480600e7a079dbbaa3c2fa08e206b8a924a9',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/datamart-indicator/datamart-indicator.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 21
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 27
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 25
        }
      },
      '3': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 31
        }
      },
      '4': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 38,
          column: 11
        }
      },
      '5': {
        start: {
          line: 22,
          column: 10
        },
        end: {
          line: 22,
          column: 28
        }
      },
      '6': {
        start: {
          line: 25,
          column: 10
        },
        end: {
          line: 25,
          column: 33
        }
      },
      '7': {
        start: {
          line: 28,
          column: 10
        },
        end: {
          line: 28,
          column: 40
        }
      },
      '8': {
        start: {
          line: 35,
          column: 10
        },
        end: {
          line: 37,
          column: 13
        }
      },
      '9': {
        start: {
          line: 43,
          column: 0
        },
        end: {
          line: 134,
          column: 5
        }
      },
      '10': {
        start: {
          line: 63,
          column: 20
        },
        end: {
          line: 63,
          column: 24
        }
      },
      '11': {
        start: {
          line: 64,
          column: 35
        },
        end: {
          line: 64,
          column: 39
        }
      },
      '12': {
        start: {
          line: 65,
          column: 30
        },
        end: {
          line: 65,
          column: 34
        }
      },
      '13': {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 73,
          column: 8
        }
      },
      '14': {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 71
        }
      },
      '15': {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 61
        }
      },
      '16': {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 31
        }
      },
      '17': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 88,
          column: 8
        }
      },
      '18': {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 87
        }
      },
      '19': {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 71
        }
      },
      '20': {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 103
        }
      },
      '21': {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 86,
          column: 9
        }
      },
      '22': {
        start: {
          line: 83,
          column: 10
        },
        end: {
          line: 85,
          column: 13
        }
      },
      '23': {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 61
        }
      },
      '24': {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 96,
          column: 8
        }
      },
      '25': {
        start: {
          line: 91,
          column: 8
        },
        end: {
          line: 95,
          column: 9
        }
      },
      '26': {
        start: {
          line: 92,
          column: 10
        },
        end: {
          line: 94,
          column: 13
        }
      },
      '27': {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 103,
          column: 8
        }
      },
      '28': {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 102,
          column: 11
        }
      },
      '29': {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 115,
          column: 8
        }
      },
      '30': {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 114,
          column: 11
        }
      },
      '31': {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 125,
          column: 8
        }
      },
      '32': {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 124,
          column: 44
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 7,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 12
          },
          end: {
            line: 11,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 14
          },
          end: {
            line: 39,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 21,
            column: 15
          },
          end: {
            line: 21,
            column: 16
          }
        },
        loc: {
          start: {
            line: 21,
            column: 21
          },
          end: {
            line: 23,
            column: 9
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 24,
            column: 20
          },
          end: {
            line: 24,
            column: 21
          }
        },
        loc: {
          start: {
            line: 24,
            column: 26
          },
          end: {
            line: 26,
            column: 9
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 27,
            column: 27
          },
          end: {
            line: 27,
            column: 28
          }
        },
        loc: {
          start: {
            line: 27,
            column: 33
          },
          end: {
            line: 29,
            column: 9
          }
        }
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 9
          }
        },
        loc: {
          start: {
            line: 34,
            column: 20
          },
          end: {
            line: 38,
            column: 9
          }
        }
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 62,
            column: 16
          },
          end: {
            line: 62,
            column: 17
          }
        },
        loc: {
          start: {
            line: 62,
            column: 34
          },
          end: {
            line: 133,
            column: 5
          }
        }
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 67,
            column: 22
          },
          end: {
            line: 67,
            column: 23
          }
        },
        loc: {
          start: {
            line: 67,
            column: 34
          },
          end: {
            line: 73,
            column: 7
          }
        }
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 75,
            column: 29
          },
          end: {
            line: 75,
            column: 30
          }
        },
        loc: {
          start: {
            line: 75,
            column: 41
          },
          end: {
            line: 88,
            column: 7
          }
        }
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 90,
            column: 19
          },
          end: {
            line: 90,
            column: 20
          }
        },
        loc: {
          start: {
            line: 90,
            column: 31
          },
          end: {
            line: 96,
            column: 7
          }
        }
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 99,
            column: 31
          },
          end: {
            line: 99,
            column: 32
          }
        },
        loc: {
          start: {
            line: 99,
            column: 48
          },
          end: {
            line: 103,
            column: 7
          }
        }
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 111,
            column: 27
          },
          end: {
            line: 111,
            column: 28
          }
        },
        loc: {
          start: {
            line: 111,
            column: 39
          },
          end: {
            line: 115,
            column: 7
          }
        }
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 123,
            column: 30
          },
          end: {
            line: 123,
            column: 31
          }
        },
        loc: {
          start: {
            line: 123,
            column: 51
          },
          end: {
            line: 125,
            column: 7
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }, {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 95,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 95,
            column: 9
          }
        }, {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 95,
            column: 9
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatamartIndicatorComponent = function () {
  function DatamartIndicatorComponent($log, $uibModal, $state, $filter, lodash) {
    _classCallCheck(this, DatamartIndicatorComponent);

    ++cov_jko19f4gi.f[0];
    ++cov_jko19f4gi.s[0];

    this.$log = $log;
    ++cov_jko19f4gi.s[1];
    this.$filter = $filter;
    ++cov_jko19f4gi.s[2];
    this.lodash = lodash;
    ++cov_jko19f4gi.s[3];
    this.$uibModal = $uibModal;
  }

  _createClass(DatamartIndicatorComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_jko19f4gi.f[1];
    }

    /**
     * Open modal.
     */

  }, {
    key: 'openModal',
    value: function openModal() {
      var _this = this;

      ++cov_jko19f4gi.f[2];
      ++cov_jko19f4gi.s[4];

      this.$uibModal.open({
        component: 'modalComponent',
        resolve: {
          marts: function marts() {
            ++cov_jko19f4gi.f[3];
            ++cov_jko19f4gi.s[5];

            return _this.marts;
          },
          indicators: function indicators() {
            ++cov_jko19f4gi.f[4];
            ++cov_jko19f4gi.s[6];

            return _this.indicators;
          },
          selectedIndicator: function selectedIndicator() {
            ++cov_jko19f4gi.f[5];
            ++cov_jko19f4gi.s[7];

            return _this.selectedIndicator;
          }
        }
      }).result.then(function (response) {
        ++cov_jko19f4gi.f[6];
        ++cov_jko19f4gi.s[8];

        _this.onChange({
          value: response
        });
      });
    }
  }]);

  return DatamartIndicatorComponent;
}();

++cov_jko19f4gi.s[9];


angular.module('app').component('datamartIndicator', {
  bindings: {
    marts: '<',
    indicators: '<',
    onChange: '&',
    selectedIndicator: '='
  },
  templateUrl: 'app/dashboard/datamart-indicator/datamart-indicator.template.html',
  controller: DatamartIndicatorComponent
}).component('modalComponent', {
  templateUrl: 'modal.html',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: function controller(lodash) {
    ++cov_jko19f4gi.f[7];

    var $ctrl = (++cov_jko19f4gi.s[10], this);
    var cloneSelectedIndicator = (++cov_jko19f4gi.s[11], null);
    var cloneSelectedMart = (++cov_jko19f4gi.s[12], null);

    ++cov_jko19f4gi.s[13];
    $ctrl.$onInit = function () {
      ++cov_jko19f4gi.f[8];
      ++cov_jko19f4gi.s[14];

      // indicators & marts
      $ctrl.indicators = lodash.get($ctrl.resolve, 'indicators', []);
      ++cov_jko19f4gi.s[15];
      $ctrl.marts = lodash.get($ctrl.resolve, 'marts', []);
      // Previous Select.
      ++cov_jko19f4gi.s[16];
      $ctrl.previousSelect();
    };

    ++cov_jko19f4gi.s[17];
    $ctrl.previousSelect = function () {
      ++cov_jko19f4gi.f[9];
      ++cov_jko19f4gi.s[18];

      // selected indicator
      $ctrl.selectedIndicator = lodash.get($ctrl.resolve, 'selectedIndicator', null);
      ++cov_jko19f4gi.s[19];
      cloneSelectedIndicator = angular.copy($ctrl.selectedIndicator);
      // selected mart
      ++cov_jko19f4gi.s[20];
      $ctrl.selectedMart = lodash.get($ctrl.selectedIndicator, 'datamart', lodash.head($ctrl.marts));
      // is String.
      ++cov_jko19f4gi.s[21];
      if (lodash.isString($ctrl.selectedMart)) {
        ++cov_jko19f4gi.b[0][0];
        ++cov_jko19f4gi.s[22];

        $ctrl.selectedMart = lodash.find($ctrl.marts, {
          id: $ctrl.selectedMart
        });
      } else {
        ++cov_jko19f4gi.b[0][1];
      }
      ++cov_jko19f4gi.s[23];
      cloneSelectedMart = angular.copy($ctrl.selectedMart);
    };

    ++cov_jko19f4gi.s[24];
    $ctrl.save = function () {
      ++cov_jko19f4gi.f[10];
      ++cov_jko19f4gi.s[25];

      if ($ctrl.selectedIndicator) {
        ++cov_jko19f4gi.b[1][0];
        ++cov_jko19f4gi.s[26];

        $ctrl.close({
          $value: $ctrl.selectedIndicator
        });
      } else {
        ++cov_jko19f4gi.b[1][1];
      }
    };

    // Listen Mart change.
    ++cov_jko19f4gi.s[27];
    $ctrl.listenMartChange = function (value) {
      ++cov_jko19f4gi.f[11];
      ++cov_jko19f4gi.s[28];

      $ctrl.indicators = lodash.filter($ctrl.resolve.indicators, {
        datamart: value.id
      });
    };

    /**
     * CLose and save
     * @method closeAndSave
     * @return {}
     */

    ++cov_jko19f4gi.s[29];
    $ctrl.closeAndSave = function () {
      ++cov_jko19f4gi.f[12];
      ++cov_jko19f4gi.s[30];

      $ctrl.close({
        $value: cloneSelectedIndicator
      });
    };

    /**
     * Sélectionnez un indicateur.
     * @method selectIndicator
     * @return {}
     */

    ++cov_jko19f4gi.s[31];
    $ctrl.selectIndicator = function (indicator) {
      ++cov_jko19f4gi.f[13];
      ++cov_jko19f4gi.s[32];

      $ctrl.selectedIndicator = indicator;
    };

    //
    // $ctrl.cancel = function () {
    //   $ctrl.dismiss({
    //     $value: 'cancel'
    //   });
    // };
  }
});